export enum GroupBy {
    Date = 'date',
    Agent = 'agent',
    Company = 'company',
    Detail = 'detail'
}
